export default __webpack_public_path__ + "static/cv-ced30636ccd8c6f89d0ca0d60447f8f2.pdf";